import React from 'react';
import Button from '../UI/Button';

const LoadFundsUI = props => {
  const {inputValue, setInputValue, title, loadOptions, disabled} = props;

  function changeHandler(e) {
    if (!isNaN(e.target.value)) setInputValue(e.target.value);
  }

  const disabledStyles = disabled
    ? 'text-black opacity-50 pointer-events-none'
    : 'text-black';

  return (
    <div className='grid grid-cols-6 gap-4 max-w-lg'>
      <span className='border-2 box-content border-gray-400 rounded-md p-3 h-fit col-start-1 col-span-2'>
        {`$ `}
        <input
          title={`input ${title}`}
          value={inputValue}
          className={`text-xl focus:outline-none w-3/4 ${disabledStyles}`}
          type='text'
          onChange={changeHandler}
        />
      </span>
      <div
        className={`col-start-3 col-end-7 flex items-center ${disabledStyles}`}
      >
        {props.children}
      </div>
      {loadOptions.map(loadOption => {
        return (
          <Button
            disabled={disabled}
            key={loadOption}
            onClick={() => setInputValue(loadOption)}
            className={`row-start-2 flex justify-center items-center font-normal border-gray-400 hover:border-gray-900 p-2`}
          >{`$${loadOption}`}</Button>
        );
      })}
    </div>
  );
};

export default LoadFundsUI;
